const React = require('react');
const PropTypes = require('prop-types');

require('./RiskTriangle.scss');


const RiskTriangle = ({ index }) => (
    <div className="risk-indicator__risk-triangle">
        <div className="risk-indicator__risk-triangle__outer-triangle">
            <div
                className="risk-indicator__risk-triangle__inner-triangle"
                style={{
                    borderWidth: `${(index - 1) * 8}px ${(index - 1) * 42}px 0 0`,
                    marginTop: `-${(index - 1) * 8}px`,
                }}
            />
        </div>
    </div>
);


RiskTriangle.propTypes = {
    index: PropTypes.number.isRequired,
};


module.exports = RiskTriangle;
